import React from "react";
import { buildFaqPageJsonLdString } from "../../utils/faqPageJsonLd";

export interface FaqPageJsonLdProps {
  /** The page's Storyblok blocks, as the canvas receives them. */
  components?: unknown;
  /** Optional id so the block is addressable; defaults to the page-level FAQ schema id. */
  id?: string;
}

/** One page, one FAQPage claim — so the id is fixed rather than per-block. */
export const FAQ_PAGE_JSONLD_ID = "faq-page-schema";

/**
 * HIM-4783 — renders the page's single `application/ld+json` FAQPage block.
 *
 * A sibling of the canvas rather than a child of any FAQ block: the questions come from every
 * FAQ on the page, and a per-block script would be the duplicate claim this replaces. Renders
 * nothing when the page has no eligible FAQ. Content is HTML-stripped and `<` is escaped in
 * the builder, so `dangerouslySetInnerHTML` cannot inject markup or break out of the script
 * tag.
 */
export const FaqPageJsonLd: React.FC<FaqPageJsonLdProps> = ({
  components,
  id = FAQ_PAGE_JSONLD_ID
}) => {
  const json = buildFaqPageJsonLdString(components);
  if (!json) {
    return null;
  }
  return (
    <script
      type="application/ld+json"
      id={id}
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
};

export default FaqPageJsonLd;
